import axiosInstance from "../config/axiosInterceptor";

export async function getAggregation(widgetBody, url, nodeId = null) {
  const normalizedUrl = url.startsWith("/") ? url : `/${url}`;
  const fullUrl = nodeId ? `${normalizedUrl}/${nodeId}` : normalizedUrl;

  // Kullanıcının timezone offset'ini hesapla
  // getTimezoneOffset() UTC'den farkı dakika cinsinden negatif verir
  // Örn: UTC+3 için getTimezoneOffset() = -180, -180 / -60 = 3
  // Örn: UTC-5 için getTimezoneOffset() = 300, 300 / -60 = -5
  const userTimezoneOffset = -(new Date().getTimezoneOffset() / 60);

  // widgetBody'yi parse et, gmtZone ekle ve tekrar stringify et
  let bodyWithTimezone = widgetBody;
  try {
    const parsedBody =
      typeof widgetBody === "string" ? JSON.parse(widgetBody) : widgetBody;
    parsedBody.gmtZone = userTimezoneOffset;
    bodyWithTimezone = JSON.stringify(parsedBody);
  } catch (e) {
    // Parse hatasında orijinal body'yi kullan
    console.warn("widgetBody parse hatası, orijinal body kullanılıyor:", e);
  }

  return await axiosInstance.post(fullUrl, bodyWithTimezone);
}

// import axios from 'axios';

// export async function getAggregation(widgetBody, url, nodeId = null) {
//   // Baştaki slash'ı temizleyerek çakışmayı önleyelim
//   const cleanUrl = url.startsWith("/") ? url.substring(1) : url;

//   // IP adresini doğrudan buraya ekleyelim
//   const domain = "https://10.1.61.1:3000";
//   const fullUrl = nodeId ? `${domain}/${cleanUrl}/${nodeId}` : `${domain}/${cleanUrl}`;

//   try {
//     const response = await axios.post(fullUrl, widgetBody);
//     return response.data;
//   } catch (error) {
//     console.error("İstek hatası:", error);
//     throw error;
//   }
// }

// import axios from "axios";
// import https from "https"; // Sadece Node.js ortamındaysanız sertifika hatası için gerekebilir

// export async function getAggregation(widgetBody, url, nodeId = null) {
//   const authToken = localStorage.getItem("authToken");

//   const domain = "https://10.1.61.1:3000";
//   const cleanUrl = url.startsWith("/") ? url : `/${url}`;
//   const fullUrl = nodeId
//     ? `${domain}${cleanUrl}/${nodeId}`
//     : `${domain}${cleanUrl}`;

//   try {
//     const response = await axios.post(fullUrl, widgetBody, {
//       headers: {
//         "Content-Type": "application/json", // Sunucuya JSON gönderdiğimizi söylüyoruz
//         Accept: "application/json", // Sunucudan JSON beklediğimizi söylüyoruz
//         Authorization: `Bearer ${authToken}`,
//       },
//       // Eğer tarayıcıda değil de Node.js'deyseniz alttaki satırı aktif edin:
//       // httpsAgent: new https.Agent({ rejectUnauthorized: false })
//     });

//     return response.data;
//   } catch (error) {
//     if (error.response) {
//       // Sunucudan gelen hata detayını görmek için:
//       console.error("Hata Kodu:", error.response.status);
//       console.error("Hata Mesajı:", error.response.data);
//     }
//     throw error;
//   }
// }

// import axios from "axios";

// export async function getAggregation(widgetBody, url, nodeId = null) {
//   const authToken = localStorage.getItem("authToken");

//   const domain = "https://10.1.61.1:3000";
//   const cleanUrl = url.startsWith("/") ? url : `/${url}`;
//   const fullUrl = nodeId
//     ? `${domain}${cleanUrl}/${nodeId}`
//     : `${domain}${cleanUrl}`;

//   try {
//     const response = await axios.post(fullUrl, widgetBody, {
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         Authorization: `Bearer ${authToken}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error(
//       "İstek Hatası:",
//       error.response?.status,
//       error.response?.data
//     );
//     throw error;
//   }
// }
